import gql from 'graphql-tag'
import { IConnectionWithTotal, IWorkplaceGroupSpace } from '@api/types'
import { WorkplaceGroupSpaces } from '@api/fragments'
import client from '../../stores/apollo'

interface Payload {
  data: {
    node: { spaces: IConnectionWithTotal<IWorkplaceGroupSpace> }
  }
}

export const workplaceGroupSpacesQuery = gql`
  query WorkplaceGroupSpaces($id: ID!, $where: SpaceWhereInput, $first: Int, $after: String) {
    node(id: $id) {
      ... on WorkplaceGroup {
        ...WorkplaceGroupSpaces
      }
    }
  }
  ${WorkplaceGroupSpaces}
`

export default function spaces(variables: {
  workplaceGroupId: string
  first?: number
  query?: string
  after?: string
}): Promise<IConnectionWithTotal<IWorkplaceGroupSpace>> {
  const { workplaceGroupId, first = 5, query = '', after = '' } = variables

  return client.gql
    .query({
      query: workplaceGroupSpacesQuery,
      variables: {
        id: workplaceGroupId,
        first,
        where: {
          OR: [{ externalId_contains: query }, { name_contains: query }],
        },
        after,
      },
    })
    .then(({ data: { node } }: Payload) => node.spaces)
}
